import useEmblaCarousel from "embla-carousel-react";
import { useState } from "react";

import type { getPackShotGalleryComponent } from "@/lib/api/formatting/rorosTweed/productPage";
import useDevice from "@/lib/hooks/useDevice";

import UI from "./UI";

export type PackshotGalleryProps =
  | Partial<ReturnType<typeof getPackShotGalleryComponent>>
  | undefined;

const PackshotGallery = (props: PackshotGalleryProps) => {
  const [imageIndex, setImageIndex] = useState(0);
  const [zoomed, setZoomed] = useState(false);
  const media = props?.media;
  const { mobile } = useDevice();

  const [emblaRef] = useEmblaCarousel({ loop: true });

  if (!media || media.length === 0) {
    return <></>;
  }

  const increment = () =>
    zoomed
      ? () => {}
      : imageIndex < media.length - 1
      ? setImageIndex(imageIndex + 1)
      : setImageIndex(0);

  const decrement = () =>
    zoomed
      ? () => {}
      : imageIndex > 0
      ? setImageIndex(imageIndex - 1)
      : setImageIndex(media.length - 1);

  const imageSetters = () =>
    media.map((_image, index) => ({
      active: index === imageIndex,
      callback: () => setImageIndex(index),
      value: index + 1,
    }));

  const uiProps = {
    media,
    imageIndex,
    increment,
    decrement,
    imageSetters,
    mobile,
    emblaRef,
    setZoomed,
    zoomed,
  };

  return (
    <>
      <UI {...uiProps} />
    </>
  );
};

export default PackshotGallery;
